import {DetailScreen} from '../mapping-classes/detail-screen';
import {DetailLabel} from '../mapping-classes/detail-label';
import {DetailPanel} from '../mapping-classes/detail-panel';

export class Dienstverleningsovereenkomst implements DetailScreen {
  restrictedData: boolean;
  title: string;
  buttons;
  panels: DetailPanel[];
  nameValues: DetailLabel[];
  shieldedText = 'Afgeschermd';
  errorText: string;
  currentDate: Date;

  constructor(response: any) {
    this.title = 'Dienstverleningsovereenkomst';
    if (response.listOfError) {
      this.createErrorMessage(response);
    } else {
      this.restrictedData = response.detailsViewObject['restrictedData'];
      this.panels = [];
      this.nameValues = [];
      this.buttons = [];
      this.setPanels();
      this.setNameAndValues();
      this.addValues(response);
    }
  }

  createErrorMessage(response) {
    if (response.listOfError && response.listOfError.length !== 0) {
      if (response.listOfError[0].code === 'CIV_F025') {
        this.errorText = 'Geen detail gegevens gevonden.';
      } else if (response.listOfError[0].code) {
        this.errorText = 'Product niet gevonden.';
      }
    }
  }

  setPanels() {
    this.panels.push(new DetailPanel('Productkenmerken'));
    this.panels.push(new DetailPanel('Productafspraken'));
    const productAgreementsPanel: DetailPanel = this.panels[1];
    productAgreementsPanel.subPanels.push(new DetailPanel('Vergoeding'));
    productAgreementsPanel.subPanels.push(new DetailPanel('Verrekening'));
  }

  setNameAndValues() {
    const productDetailsPanel: DetailPanel = this.panels[0];
    productDetailsPanel.nameAndValues.set('arrangementNumber', new DetailLabel('Overeenkomstnummer'));
    productDetailsPanel.nameAndValues.set('baseArrangementNumber', new DetailLabel('Kenmerk bancair product'));

    const productAgreementsPanel: DetailPanel = this.panels[1];
    productAgreementsPanel.nameAndValues.set('activationDate', new DetailLabel('Ingangsdatum bancair product'));
    productAgreementsPanel.nameAndValues.set('terminationDate', new DetailLabel('Einddatum bancair product'));

    const compensationSubPanel: DetailPanel = productAgreementsPanel.subPanels[0];
    compensationSubPanel.nameAndValues.set('compensationsTypeAdvice', new DetailLabel('Adviesvergoeding'));
    compensationSubPanel.nameAndValues.set('serviceFeeTotalCustomerAmountAdvice', new DetailLabel('Bedrag adviesvergoeding'));
    compensationSubPanel.nameAndValues.set('compensationsTypeExcecution', new DetailLabel('Afsluitvergoeding'));
    compensationSubPanel.nameAndValues.set('serviceFeeTotalCustomerAmountExecution', new DetailLabel('Bedrag afsluitvergoeding'));
    compensationSubPanel.nameAndValues.set('compensationsTypeService', new DetailLabel('Periodieke vergoeding'));
    compensationSubPanel.nameAndValues.set('serviceFeeTotalCustomerAmountService', new DetailLabel('Bedrag periodieke vergoeding'));
    compensationSubPanel.nameAndValues.set('maintenanceFeePaymentSuspensionFlag', new DetailLabel('Opschortindicatie DVO'));

    const settlementSubPanel: DetailPanel = productAgreementsPanel.subPanels[1];
    settlementSubPanel.nameAndValues.set('factureDependingOnPaymentType', new DetailLabel('Factuur'));
    settlementSubPanel.nameAndValues.set('mandateId', new DetailLabel('SEPA mandaat ID'));
    settlementSubPanel.nameAndValues.set('directDebitAccountIban', new DetailLabel('Incassorekening nummer (IBAN)'));
    settlementSubPanel.nameAndValues.set('maintenanceFeePaymentFrequencyTypeCode', new DetailLabel('Frequentie periodieke vergoeding'));
    settlementSubPanel.nameAndValues.set('incassoActivationDate', new DetailLabel('Ingangsdatum verrekening'));
  }

  addValues(response) {
    const obj = response.detailsViewObject;
    const productDetailsPanel: DetailPanel = this.panels[0];
    productDetailsPanel.nameAndValues.get('arrangementNumber').setValue(obj.arrangementNumber || '-');
    productDetailsPanel.nameAndValues.get('baseArrangementNumber').setValue(obj.baseArrangementNumber || '-');

    const productAgreementsPanel: DetailPanel = this.panels[1];
    productAgreementsPanel.nameAndValues.get('activationDate').setValue(obj.activationDate || '-');
    productAgreementsPanel.nameAndValues.get('terminationDate').setValue(obj.terminationDate || '-');

    const compensationSubPanel: DetailPanel = productAgreementsPanel.subPanels[0];
    const settlementSubPanel: DetailPanel = productAgreementsPanel.subPanels[1];

    if (obj.compensations !== null) {
      obj.compensations.forEach(compensation => {
        if (compensation.type == 'ADVICE') {
          compensationSubPanel.nameAndValues.get('compensationsTypeAdvice').setValue('Ja' || '-');
          compensationSubPanel.nameAndValues.get('serviceFeeTotalCustomerAmountAdvice').setValue(compensation.baseAmount);
          compensationSubPanel.nameAndValues.get('serviceFeeTotalCustomerAmountAdvice').setType('amount');
        } else if (compensation.type == 'EXECUTION') {
          compensationSubPanel.nameAndValues.get('compensationsTypeExcecution').setValue('Ja' || '-');
          compensationSubPanel.nameAndValues.get('serviceFeeTotalCustomerAmountExecution').setValue(compensation.baseAmount);
          compensationSubPanel.nameAndValues.get('serviceFeeTotalCustomerAmountExecution').setType('amount');
        } else if (compensation.type == 'SERVICE') {
          compensationSubPanel.nameAndValues.get('compensationsTypeService').setValue('Ja' || '-');
          compensationSubPanel.nameAndValues.get('serviceFeeTotalCustomerAmountService').setValue(compensation.baseAmount);
          compensationSubPanel.nameAndValues.get('serviceFeeTotalCustomerAmountService').setType('amount');
          settlementSubPanel.nameAndValues.get('maintenanceFeePaymentFrequencyTypeCode').setValue(compensation.frequency);
        } else {
          settlementSubPanel.nameAndValues.get('maintenanceFeePaymentFrequencyTypeCode').setValue('-');
        }
      });
    }

    this.currentDate = new Date();
    if (obj.suspension &&
      (((Date.parse(obj.creationDate) <= this.currentDate.getTime()) && ((Date.parse(obj.terminationDate) > this.currentDate.getTime())) ||
        (obj.creationDate && (Date.parse(obj.terminationDate) > this.currentDate.getTime())) ||
        (obj.creationDate && !obj.terminationDate)))) {
      compensationSubPanel.nameAndValues.get('maintenanceFeePaymentSuspensionFlag').setValue('Ja');
    } else {
      compensationSubPanel.nameAndValues.get('maintenanceFeePaymentSuspensionFlag').setValue('Nee');
    }

    if (obj.collection !== null) {
      if (obj.collection.paymentType === 'INVOICE') {
        settlementSubPanel.nameAndValues.get('factureDependingOnPaymentType').setValue('Ja');
      } else {
        settlementSubPanel.nameAndValues.get('factureDependingOnPaymentType').setValue('Nee');
      }
      settlementSubPanel.nameAndValues.get('mandateId').setValue(obj.collection.mandateId || '-');
      settlementSubPanel.nameAndValues.get('directDebitAccountIban').setValue((obj.collection.paymentAccount) ? obj.collection.paymentAccount.iban : '-');
    }



    settlementSubPanel.nameAndValues.get('incassoActivationDate').setValue(obj.activationDate || '-');
  }
}
